import React, { useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading'
import { Trans } from 'react-i18next'

export default function Login(props) {
    const [errorMessage, setErrorMessage] = useState('')
    const { t, locale } = useTranslation()
    const [progress, setProgress] = useState(false)

    const disabled = useMemo(() => {
        return !props.email || !props.password
    }, [props.email, props.password])

    const handleSubmit = async (e) => {
        e.preventDefault()

        setProgress(true)

        const resp = await props.onSubmit({
            email: props.email,
            password: props.password,
        })
        if (!resp?.success) {
            setErrorMessage(resp.data)
        }

        setProgress(false)
    }

    return (
        <>
            <div className="">
                <div className="font-bold text-textLight text-left text-3xl">{t('staffLogin')}</div>
                <div className="text-textLight text-sm text-left mt-3">
                    <p>{t('enterYourWorkEmailAndPassword')}</p>
                </div>
                <div className="sign-up-section">
                    <div className="login-forma flex flex-col justify-center">
                        <form onSubmit={handleSubmit}>
                            <div className="my-5">
                                <span className="text-textLight text-lg font-semibold text-left flex justify-start">{t('email')}</span>
                                <input
                                    className="w-full text-textLight border border-b-grey py-3 border-x-0 border-t-0"
                                    placeholder={t('email')}
                                    style={{ backgroundColor: 'transparent' }}
                                    value={props.email}
                                    // type="email"
                                    name="email"
                                    onChange={(e) => props.setEmail(e.target.value)}
                                />
                            </div>
                            <div className="my-5">
                                <span className="text-textLight text-lg font-semibold text-left flex justify-start">{t('password')}</span>
                                <input
                                    className="w-full text-textLight border border-b-deselectPurple py-3 border-x-0 border-t-0"
                                    placeholder={t('password')}
                                    value={props.password}
                                    type="password"
                                    style={{ backgroundColor: 'transparent' }}
                                    onChange={(e) => props.setPassword(e.target.value)}
                                    name="passwordLogin"
                                />
                            </div>
                            <div className="error-message">{errorMessage}</div>
                            <div className="flex justify-center px-10 mt-8 mb-3">
                                <button
                                    className={`bg-white text-textDark py-3 text-lg font-semibold rounded-full w-full h-[50px] ${
                                        !progress && !disabled ? 'hover:bg-aquaPulse hover:text-textLight' : ''
                                    } duration-[250ms] ease-in-out transition-all flex items-center justify-center`}
                                    disabled={progress || disabled}
                                >
                                    {progress ? <Loading primaryColor="var(--deep-ocean)" secondaryColor="vat(--deep-ocean)" /> : t('login')}
                                </button>
                            </div>
                        </form>
                    </div>
                    <div>
                        <p className="login-missing-text mb-2">
                            <span className="login-missing-text-q">{t('forgotPassword')}</span>
                            <span className="login-missing-text-action" onClick={() => props.setAuthSection('new-password')}>
                                {t('requestNewPassword')}
                            </span>
                        </p>
                        {/* <p
                            className="login-missing-text mb-4"
                            style={{ color: '#FFFFFF99', cursor: 'pointer' }}
                            onClick={() => window.open('https://upstrive.de/for-schools-wellbeing-upstrive-education/', '_blank')}
                        >
                            <Trans
                                i18nKey="visitOurWebsiteForMoreDetails"
                                components={{
                                    white: <span className="text-textLight" />,
                                }}
                            />
                        </p> */}
                    </div>
                </div>
            </div>
        </>
    )
}
